import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';

import { PagesModule } from './pages/pages.module';
import { SharedModule } from './shared/shared.module';
import { SwiperModule } from 'swiper/angular';
import { NgxLoadingModule } from 'ngx-loading';

import { services } from '@app/core/services';

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserAnimationsModule,
		BrowserModule.withServerTransition({ appId: 'serverApp' }),
		FormsModule,
		HttpClientModule,
		RouterModule,
		AppRoutingModule,
		PagesModule,
		SharedModule,
		SwiperModule,
		NgxLoadingModule,
	],
	providers: [...services],
	bootstrap: [AppComponent],
})
export class AppModule {}
